import script from "./LaPermissions.vue?vue&type=script&setup=true&lang=js"
export * from "./LaPermissions.vue?vue&type=script&setup=true&lang=js"

import "./LaPermissions.vue?vue&type=style&index=0&id=804a5b90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-804a5b90"]])

export default __exports__